/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { BuilderUserProfileDto } from './builder-user-profile.dto';
import { BuilderUserProfileMapper } from './builder-user-profile.mapper';
import { map$ } from '@gh/rx/operators';

@Injectable()
export class BuilderUserProfileRestService extends AbstractRestService {

  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(): Observable<BuilderUserProfileDto> {
    const justLoggedIn = window.sessionStorage.getItem('auth:justLoggedIn') === '1';
    let refresh = justLoggedIn ? 'false' : 'true';
    const justLoggedInOffice = window.sessionStorage.getItem('auth:justLoggedInOffice') === '1';
    const justLoggedInMaster = window.sessionStorage.getItem('auth:justLoggedInMaster') === '1';
    if (justLoggedInMaster && location.pathname.startsWith('/master-view')) {
      window.sessionStorage.removeItem('auth:justLoggedInMaster');
      refresh = 'false';
    } else if (justLoggedInOffice && location.pathname.startsWith('/office-view')) {
      window.sessionStorage.removeItem('auth:justLoggedInOffice');
      refresh = 'false';
    }
    return this.httpGet(`${this.bp}/profiles/me?refresh=${refresh}`,
      BuilderUserProfileMapper).pipe(map$((me) => {
      this.setAccountingUrl(me.accountingVersion);
      return me;
    }));
  }

  getMaintenanceInfo(): Observable<any> {
    return this.httpGet(`/maintenance/rest/maintenance-status`, identity());
  }



  logout(): Observable<any> {
    return this.httpGet(`${this.bp}/profiles/logout`, identity());
  }

  changeLanguage(language: string): Observable<any> {
    return this.httpPut(`${this.bp}/users/change-language`, language, identity());
  }
}
